import RouteBlockageList from '../RouteBlockageList';
import AddRouteBlockage from '../AddRouteBlockage';
import RouteBlockageEdit from '../RouteBlockageEdit';

import { CompanyList, CompanyEdit, CompanyAdd } from '../Company';
import { BusList, BusEdit, BusAdd } from '../Bus';
import { ApiUserList, ApiUserEdit, ApiUserAdd } from '../ApiUser';
import { RideAdminActiveList, RideAdminInactiveList } from '../RideAdmin';
import RailwayList from "../Railway/List";
import RailwayEdit from "../Railway/Edit";

export default {
  'routeBlockageList': RouteBlockageList,
  'addRouteBlockage': AddRouteBlockage,
  'routeBlockageEdit': RouteBlockageEdit,

  'companyList': CompanyList,
  'companyEdit': CompanyEdit,
  'companyAdd': CompanyAdd,

  'busList': BusList,
  'busEdit': BusEdit,
  'busAdd': BusAdd,

  'apiUserList': ApiUserList,
  'apiUserEdit': ApiUserEdit,
  'apiUserAdd': ApiUserAdd,

  'RideAdminActiveList': RideAdminActiveList,
  'RideAdminInactiveList': RideAdminInactiveList,

  'railwayList': RailwayList,
  'railwayEdit': RailwayEdit,
}
